// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__q4Mu5","textbox":"styles_textbox__2hMCO"};